import TagDetailContainer from './TagDetailContainer';
export default TagDetailContainer;
